// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__uLjTY","image":"styles_image__oUXAU","overlay":"styles_overlay__WFoUO","details":"styles_details__q861y","title":"styles_title__jamlW"};